import test from "./test";
import pbhRequestInfoUpdate from "./pbhRequestInfoUpdate";
import pbhFiles from "./pbhFiles";
import pbhDashboard from "./pbhDashboard";

const rootReducer = {
  counter: test,
  pbhRequestInfoUpdate: pbhRequestInfoUpdate,
  pbhFiles: pbhFiles,
  pbhDashboard: pbhDashboard,
};

export default rootReducer;
